/* Canonical source: cleanup-liquiflow.sh (MOTION_INIT_CANONICAL_EOF). CI overwrites this file each cleanup run. */
(function() {
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /**
   * ScrollTrigger start "top 85%" often never fires for above-the-fold blocks when the user
   * only scrolls down (the element's top never crosses the 85% line). Theme CSS keeps
   * [data-animate] at opacity: 0 until GSAP runs, and .gsap-ready disables the CSS fallback —
   * so those blocks can stay invisible. If the trigger is already in the reveal band, tween
   * without ScrollTrigger.
   */
  function isInRevealBand(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    if (vh <= 0) return false;
    var line = vh * 0.85;
    return r.top < line && r.bottom > 0;
  }

  /** Any non-none transform on an ancestor breaks position:fixed (hero video lightbox modal). */
  function containsLightboxModal(el) {
    return !!(el.querySelector && el.querySelector("#videoLightboxModal"));
  }

  function initFadeUp(root) {
    var items = root.querySelectorAll('[data-animate="fade-up"]');
    if (!items.length) return;
    items.forEach(function(el) {
      if (prefersReducedMotion) {
        gsap.set(el, { opacity: 1, y: 0 });
        return;
      }
      var to = {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power2.out"
      };
      if (isInRevealBand(el)) {
        gsap.fromTo(el, { opacity: 0, y: 24 }, to);
        return;
      }
      gsap.fromTo(el, { opacity: 0, y: 24 }, Object.assign({}, to, {
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      }));
    });
  }

  function initMediaReveal(root) {
    var items = root.querySelectorAll('[data-animate="media-reveal"]');
    if (!items.length) return;
    items.forEach(function(el) {
      var withModal = containsLightboxModal(el);
      if (prefersReducedMotion) {
        if (withModal) {
          gsap.set(el, { opacity: 1, clearProps: "transform" });
        } else {
          gsap.set(el, { opacity: 1, scale: 1 });
        }
        return;
      }
      if (withModal) {
        var toLb = { opacity: 1, duration: 0.7, ease: "power2.out" };
        if (isInRevealBand(el)) {
          gsap.fromTo(el, { opacity: 0 }, toLb);
        } else {
          gsap.fromTo(el, { opacity: 0 }, Object.assign({}, toLb, {
            scrollTrigger: {
              trigger: el,
              start: "top 85%",
              once: true
            }
          }));
        }
        return;
      }
      var to = {
        opacity: 1,
        scale: 1,
        duration: 0.7,
        ease: "power2.out"
      };
      if (isInRevealBand(el)) {
        gsap.fromTo(el, { opacity: 0, scale: 0.96 }, to);
        return;
      }
      gsap.fromTo(el, { opacity: 0, scale: 0.96 }, Object.assign({}, to, {
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      }));
    });
  }

  function initStaggerGroups(root) {
    var groups = root.querySelectorAll("[data-animate-group]");
    if (!groups.length) return;
    groups.forEach(function(group) {
      var items = group.querySelectorAll('[data-animate="stagger-item"]');
      if (!items.length) return;
      if (prefersReducedMotion) {
        gsap.set(items, { opacity: 1, y: 0 });
        return;
      }
      var to = {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.08,
        ease: "power2.out"
      };
      if (isInRevealBand(group)) {
        gsap.fromTo(items, { opacity: 0, y: 24 }, to);
        return;
      }
      gsap.fromTo(items, { opacity: 0, y: 24 }, Object.assign({}, to, {
        scrollTrigger: {
          trigger: group,
          start: "top 85%",
          once: true
        }
      }));
    });
  }

  function initHoverLift(root) {
    var items = root.querySelectorAll('[data-animate="hover-lift"]');
    if (!items.length) return;
    items.forEach(function(el) {
      el.addEventListener("mouseenter", function() {
        gsap.to(el, { y: -4, duration: 0.2, ease: "power2.out" });
      });
      el.addEventListener("mouseleave", function() {
        gsap.to(el, { y: 0, duration: 0.2, ease: "power2.out" });
      });
    });
  }

  function initTimelineProgress(root) {
    var bars = root.querySelectorAll('[data-animate="timeline-progress"]');
    if (!bars.length) return;
    bars.forEach(function(bar) {
      var wrapper = bar.closest(".layout_timeline-wrapper");
      if (!wrapper) return;

      var barWrapper = bar.closest(".layout_progress-bar-wrapper");
      if (!barWrapper) return;

      var icons = wrapper.querySelectorAll(".layout_timeline-icon-wrapper");
      if (icons.length < 2) return;

      var firstIcon = icons[0];
      var lastIcon = icons[icons.length - 1];
      var wrapperRect = wrapper.getBoundingClientRect();
      var firstRect = firstIcon.getBoundingClientRect();
      var lastRect = lastIcon.getBoundingClientRect();

      var iconCenterX = firstRect.left + firstRect.width / 2 - wrapperRect.left;
      var firstCenterY = firstRect.top + firstRect.height / 2 - wrapperRect.top;
      var lastCenterY = lastRect.top + lastRect.height / 2 - wrapperRect.top;
      var barHeight = lastCenterY - firstCenterY;

      barWrapper.style.display = "block";
      barWrapper.style.left = (iconCenterX - 1) + "px";
      barWrapper.style.top = firstCenterY + "px";
      barWrapper.style.height = barHeight + "px";
      barWrapper.style.marginBottom = "0";

      bar.style.transformOrigin = "top center";

      if (prefersReducedMotion) {
        gsap.set(bar, { scaleY: 1 });
        return;
      }
      gsap.fromTo(bar,
        { scaleY: 0 },
        {
          scaleY: 1,
          ease: "none",
          scrollTrigger: {
            trigger: wrapper,
            start: "top 60%",
            end: "bottom 40%",
            scrub: 0.4
          }
        }
      );
    });
  }

  function initMotion(root) {
    initFadeUp(root);
    initMediaReveal(root);
    initStaggerGroups(root);
    initHoverLift(root);
    initTimelineProgress(root);
  }

  function startMotion() {
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    document.documentElement.classList.add("gsap-ready");
    var sections = document.querySelectorAll("[data-motion]");
    if (sections.length) {
      sections.forEach(function(section) { initMotion(section); });
    } else {
      initMotion(document);
    }
  }

  function unstickVisibleAnimates() {
    if (!window.gsap || !window.ScrollTrigger) return;
    ScrollTrigger.refresh();
    var stuck = document.querySelectorAll(
      '[data-animate="media-reveal"], [data-animate="fade-up"]'
    );
    stuck.forEach(function(el) {
      var op = parseFloat(gsap.getProperty(el, "opacity"));
      if (isNaN(op) || op > 0.05) return;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      if (vh <= 0) return;
      if (r.top < vh && r.bottom > -vh * 0.25) {
        gsap.set(el, { opacity: 1, y: 0, scale: 1, clearProps: "transform" });
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startMotion);
  } else {
    startMotion();
  }

  window.addEventListener("load", function() {
    unstickVisibleAnimates();
  });
})();
